import * as logLevel from 'loglevel'
import dotEnv from "dotenv";
import {ReactAppMode} from "./Interfaces/ReactAppModes";
import {ReactIntegrationMode} from "./Interfaces/ReactIntegrationMode";

export const loadEnvVariables = () => {
    dotEnv.config();

    let path;
    switch (process.env.NODE_ENV) {
        case "test":
            path = `../.env.test`;
            break;
        case "production":
            path = `../.env.production`;
            break;
        default:
            path = `../.env.development`;
            break;
    }
    dotEnv.config({path: path});
};

export const setupLogLevel = (props: any) => {
    if (isNotEnvVarSet(process.env.REACT_APP_LOG_LEVEL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["logLevel"]) {
            logLevel.setLevel(props["logLevel"]);
        } else {
            logLevel.setLevel('warn');
        }
    } else {
        switch ((process.env.REACT_APP_LOG_LEVEL || "").toLowerCase()) {
            case 'trace': {
                logLevel.setLevel('trace');
                break;
            }
            case 'debug': {
                logLevel.setLevel('debug');
                break;
            }
            case 'info': {
                logLevel.setLevel('info');
                break;
            }
            case 'warn': {
                logLevel.setLevel('warn');
                break;
            }
            case 'error': {
                logLevel.setLevel('error');
                break;
            }
            case 'silent': {
                logLevel.setLevel('silent');
                break;
            }
            default:
                logLevel.setLevel('warn');
        }
    }
};

export let EXPERIENCE_API_URL = "";
export let RESERVATION_API_URL = "";
export let AUTO_ADJUST_API_URL = "";
export let RESERVATION_BOOK_API_URL = "";
export let USER_CONTRACTS_API_URL = "";
export let JAHIA_CONTENT_API_URL = "";
export let JAHIA_ROOMS_API_URL = "";
export let OWNER_PROFILE_API_URL = "";
export let OWNER_PROPERTIES_API_URL = "";
export let RESERVATION_DETAIL_API_URL = "";
export let AYP_URL = "";
export let API_CALL_TIMEOUT = "60000";
export let RESERVATION_LIST_API_URL = "";
export let RESERVATION_DETAIL_API_URL_WEEKS = "";
export let COUNTRY_LIST_API_URL = "";
export let ADS_API = "";
export let POINTS_CALCULATOR_API_URL = "";
export let TRANSACTION_LIST_API_URL = "";
export let OWNER_INFO_API_URL = "";
export let HOPPER_AVAIL_INFO_API_URL = "";
export let HOPPER_MFEES_REDIRECT_URL = "";
export let HOPPER_VSE_REDIRECT_URL = "";
export let HOPPER_INELIGIBLE_TYPES_SC = "";
export let HOPPER_INELIGIBLE_TYPES_APV1 = "";
export let HOPPER_INELIGIBLE_TYPES_APV2 = "";
export let CHECK_ELIGIBILITY_URL = "";
export let WAITLIST_MANAGEMENT_LIST_API_URL = "";
export let WAITLISTS_CREATE_API_URL = "";
export let WAITLIST_API_URL = "";
export let WAITLISTS_AYP_URL = "";
export let WAITLIST_SUMMARY_REVIEW_URL = "";
export let GUEST_TERMS_API_URL = "";
export let GUEST_PROFIEL_URL = "";
export let TERMS_CONDITION_URL = "";
export let TRANSFER_POINTS_CONTRACTS_URL = "";
export let EXEC_MODE = ReactAppMode.LOCAL;
export let INTEGRATION_MODE = ReactIntegrationMode.VOA;

const isNotEnvVarSet = (envVar: string | undefined) => {
    return envVar === undefined || envVar.length === 0 || envVar.indexOf('$') >= 0;
};

export let execMode = () => {
    let mode = process.env.REACT_APP_MODE as ReactAppMode;
    if (isNotEnvVarSet(mode)) {
        if (process.env.NODE_ENV === "production") {
            EXEC_MODE = ReactAppMode.VCAP;
        }
    } else {
        EXEC_MODE = mode;
    }
}


const constructApiUrl = (apiUrl: string) => {
    if ([ReactIntegrationMode.AC, ReactIntegrationMode.VSE].includes(INTEGRATION_MODE)) {
        return apiUrl.replace('/voa', '');
    }

    return apiUrl;
};

export const configApiCalls = (props: any) => {
    INTEGRATION_MODE = props["integrationMode"];
    const sessionIntegrationMode = sessionStorage.getItem("SYSTEM_INTEGRATION_MODE");
     console.log("Integration mode is " + INTEGRATION_MODE);
     console.log("EXEC_MODE is " + EXEC_MODE);
     console.log("React session interation mode " + sessionStorage.getItem("SYSTEM_INTEGRATION_MODE"));

    if (isNotEnvVarSet(process.env.REACT_APP_EXPERIENCE_API_URL) &&
        ([ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE))) {
            console.log("FOR VCAP VOA");
        if (props && props["apiUrl"] && sessionIntegrationMode === "VOA") {
            EXPERIENCE_API_URL = props["apiUrl"];
        } else if (props && props["apiUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            EXPERIENCE_API_URL = props["apiUrl"].replace('/voa', '');
        }
    } else {
        EXPERIENCE_API_URL = constructApiUrl(process.env.REACT_APP_EXPERIENCE_API_URL || '');
    }

    if (isNotEnvVarSet(process.env.REACT_APP_CHECK_ELIGIBILITY_URL) &&
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE) ) {
        if (props && props["checkEligibilityUrl"] && sessionIntegrationMode === "VOA") {
            CHECK_ELIGIBILITY_URL = props["checkEligibilityUrl"];
        }
        else if (props && props["checkEligibilityUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            CHECK_ELIGIBILITY_URL = props["checkEligibilityUrl"].replace('/voa', '');
        }
    } else {
        CHECK_ELIGIBILITY_URL = constructApiUrl( process.env.REACT_APP_CHECK_ELIGIBILITY_URL || '');
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE) ) {
        if (props && props["apiResUrl"] && sessionIntegrationMode === "VOA") {
            RESERVATION_API_URL = props["apiResUrl"];
        }
        else if (props && props["apiResUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            RESERVATION_API_URL = props["apiResUrl"].replace('/voa', '');
        }
    } else {
        RESERVATION_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_AUTO_ADJUST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiAutoAdjustUrl"] && sessionIntegrationMode === "VOA") {
            AUTO_ADJUST_API_URL = props["apiAutoAdjustUrl"];
        }
        else if (props && props["apiAutoAdjustUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            AUTO_ADJUST_API_URL = props["apiAutoAdjustUrl"].replace('/voa', '');
        }
    } else {
        AUTO_ADJUST_API_URL = constructApiUrl( process.env.REACT_APP_AUTO_ADJUST_API_URL || '');
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_BOOK_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiBookUrl"] && sessionIntegrationMode === "VOA") {
            RESERVATION_BOOK_API_URL = props["apiBookUrl"];
        }
        else if (props && props["apiBookUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            RESERVATION_BOOK_API_URL = props["apiBookUrl"].replace('/voa', '');
        }
    } else {
        RESERVATION_BOOK_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_BOOK_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_WAITLIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiWaitlistUrl"] && sessionIntegrationMode === "VOA") {
            WAITLIST_API_URL = props["apiWaitlistUrl"];
        }
        else if (props && props["apiWaitlistUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            WAITLIST_API_URL = props["apiWaitlistUrl"].replace('/voa', '');
        }
    } else {
        WAITLIST_API_URL = constructApiUrl( process.env.REACT_APP_WAITLIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_USER_CONTRACTS_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiUserContractsUrl"] && sessionIntegrationMode === "VOA") {
            USER_CONTRACTS_API_URL = props["apiUserContractsUrl"];
        }
        else if (props && props["apiUserContractsUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            USER_CONTRACTS_API_URL = props["apiUserContractsUrl"].replace('/voa', '');
        }
    } else {
        USER_CONTRACTS_API_URL = constructApiUrl( process.env.REACT_APP_USER_CONTRACTS_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_JAHIA_CONTENT_API_BASE_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["jahiaContentApiUrl"] && sessionIntegrationMode === "VOA") {
            JAHIA_CONTENT_API_URL = props["jahiaContentApiUrl"];
        }
        else if (props && props["jahiaContentApiUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            JAHIA_CONTENT_API_URL = props["jahiaContentApiUrl"].replace('/voa', '');
        }
    } else {
        JAHIA_CONTENT_API_URL = constructApiUrl( process.env.REACT_APP_JAHIA_CONTENT_API_BASE_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_JAHIA_ROOMS_API_BASE_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["jahiaRoomsApiUrl"] && sessionIntegrationMode === "VOA") {
            JAHIA_ROOMS_API_URL = props["jahiaRoomsApiUrl"];
        }
        else if (props && props["jahiaRoomsApiUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            JAHIA_ROOMS_API_URL = props["jahiaRoomsApiUrl"].replace('/voa', '');
        }
    } else {
        JAHIA_ROOMS_API_URL = constructApiUrl( process.env.REACT_APP_JAHIA_ROOMS_API_BASE_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_OWNER_PROFILE_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiOwnerProfileUrl"] && sessionIntegrationMode === "VOA") {
            OWNER_PROFILE_API_URL = props["apiOwnerProfileUrl"];
        }
        else if (props && props["apiOwnerProfileUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            OWNER_PROFILE_API_URL = props["apiOwnerProfileUrl"].replace('/voa', '');
        }
    } else {
        OWNER_PROFILE_API_URL = constructApiUrl( process.env.REACT_APP_OWNER_PROFILE_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_AYP_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["aypUrl"] && sessionIntegrationMode === "VOA") {
            AYP_URL = props["aypUrl"];
        }
        else if (props && props["aypUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            AYP_URL = props["aypUrl"].replace('/voa', '');
        }
    } else {
        AYP_URL = constructApiUrl( process.env.REACT_APP_AYP_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_OWNER_PROPERTIES_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["ownerPropertiesUrl"] && sessionIntegrationMode === "VOA") {
            OWNER_PROPERTIES_API_URL = props["ownerPropertiesUrl"];
        }
        else if (props && props["ownerPropertiesUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            OWNER_PROPERTIES_API_URL = props["ownerPropertiesUrl"].replace('/voa', '');
        }
    } else {
        OWNER_PROPERTIES_API_URL = constructApiUrl( process.env.REACT_APP_OWNER_PROPERTIES_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_DETAIL_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["reservationDetailUrl"] && sessionIntegrationMode === "VOA") {
            console.log("VCAP VOA for reservation details url");
            RESERVATION_DETAIL_API_URL = props["reservationDetailUrl"];
        }
        else if (props && props["reservationDetailUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC for reservation details url");
            RESERVATION_DETAIL_API_URL = props["reservationDetailUrl"].replace('/voa', '');
        }
    } else {
        RESERVATION_DETAIL_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_DETAIL_API_URL || "");
    }
    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_DETAIL_API_URL_WEEKS) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["reservationDetailUrlWeeks"] && sessionIntegrationMode === "VOA") {
            RESERVATION_DETAIL_API_URL_WEEKS = props["reservationDetailUrlWeeks"];
        }
        else if (props && props["reservationDetailUrlWeeks"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            RESERVATION_DETAIL_API_URL_WEEKS = props["reservationDetailUrlWeeks"].replace('/voa', '');
        }
    } else {
        RESERVATION_DETAIL_API_URL_WEEKS = constructApiUrl( process.env.REACT_APP_RESERVATION_DETAIL_API_URL_WEEKS || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_API_CALL_TIMEOUT) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiTimeout"] && sessionIntegrationMode === "VOA") {
            API_CALL_TIMEOUT = props["apiTimeout"];
        }
        else if (props && props["apiTimeout"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            API_CALL_TIMEOUT = props["apiTimeout"].replace('/voa', '');
        }
    } else {
        API_CALL_TIMEOUT = constructApiUrl( process.env.REACT_APP_API_CALL_TIMEOUT || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiResListUrl"] && sessionIntegrationMode === "VOA") {
            RESERVATION_LIST_API_URL = props["apiResListUrl"];
        }
        else if (props && props["apiResListUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            RESERVATION_LIST_API_URL = props["apiResListUrl"].replace('/voa', '');
        }
    } else {
        RESERVATION_LIST_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_WAITLIST_MANAGEMENT_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiResWaitListUrl"] && sessionIntegrationMode === "VOA") {
            WAITLIST_MANAGEMENT_LIST_API_URL = props["apiResWaitListUrl"];
        }
        else if (props && props["apiResWaitListUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            WAITLIST_MANAGEMENT_LIST_API_URL = props["apiResWaitListUrl"].replace('/voa', '');
        }
    } else {
        WAITLIST_MANAGEMENT_LIST_API_URL = constructApiUrl( process.env.REACT_APP_WAITLIST_MANAGEMENT_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_COUNTRY_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiCountryListUrl"] && sessionIntegrationMode === "VOA") {
            COUNTRY_LIST_API_URL = props["apiCountryListUrl"];
        }
        else if (props && props["apiCountryListUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            COUNTRY_LIST_API_URL = props["apiCountryListUrl"].replace('/voa', '');
        }
    } else {
        COUNTRY_LIST_API_URL = constructApiUrl( process.env.REACT_APP_COUNTRY_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_ADS_API) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiAds"] && sessionIntegrationMode === "VOA") {
            ADS_API = props["apiAds"];
        }
        else if (props && props["apiAds"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            ADS_API = props["apiAds"].replace('/voa', '');
        }
    } else {
        ADS_API = constructApiUrl( process.env.REACT_APP_ADS_API || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_POINTS_CALCULATOR_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiPointsCalculatorUrl"] && sessionIntegrationMode === "VOA") {
            POINTS_CALCULATOR_API_URL = props["apiPointsCalculatorUrl"];
        }
        else if (props && props["apiPointsCalculatorUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            POINTS_CALCULATOR_API_URL = props["apiPointsCalculatorUrl"].replace('/voa', '');
        }
    } else {
        POINTS_CALCULATOR_API_URL = constructApiUrl( process.env.REACT_APP_POINTS_CALCULATOR_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_TRANS_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiTransListUrl"] && sessionIntegrationMode === "VOA") {
            TRANSACTION_LIST_API_URL = props["apiTransListUrl"];
        }
        else if (props && props["apiTransListUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            TRANSACTION_LIST_API_URL = props["apiTransListUrl"].replace('/voa', '');
        }
    } else {
        TRANSACTION_LIST_API_URL = constructApiUrl( process.env.REACT_APP_TRANS_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_WAITLISTS_CREATE_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiWaitlistCreateUrl"] && sessionIntegrationMode === "VOA") {
            WAITLISTS_CREATE_API_URL = props["apiWaitlistCreateUrl"];
        }
        else if (props && props["apiWaitlistCreateUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            WAITLISTS_CREATE_API_URL = props["apiWaitlistCreateUrl"].replace('/voa', '');
        }
    } else {
        WAITLISTS_CREATE_API_URL = constructApiUrl( process.env.REACT_APP_WAITLISTS_CREATE_API_URL || "");
    }


    if (isNotEnvVarSet(process.env.REACT_APP_OWNER_INFO_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiOwnerInfoUrl"] && sessionIntegrationMode === "VOA") {
            OWNER_INFO_API_URL = props["apiOwnerInfoUrl"];
        }
        else if (props && props["apiOwnerInfoUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            OWNER_INFO_API_URL = props["apiOwnerInfoUrl"].replace('/voa', '');
        } 
    } else {
        OWNER_INFO_API_URL = constructApiUrl( process.env.REACT_APP_OWNER_INFO_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_TERMS_CONDITION_URL) ||
    [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
       
       if (props && props["termsConditionUrl"] && sessionIntegrationMode === "VOA") {
            TERMS_CONDITION_URL = props["termsConditionUrl"];
        }
        else if (props && props["termsConditionUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            TERMS_CONDITION_URL = props["termsConditionUrl"].replace('/voa', '');
        }
    }
    else {
        TERMS_CONDITION_URL = constructApiUrl( process.env.REACT_APP_TERMS_CONDITION_URL || "");
    } 
    if (isNotEnvVarSet(process.env.REACT_APP_HOPPER_AVAIL_INFO_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiHopperAvailUrl"] && sessionIntegrationMode === "VOA") {
            HOPPER_AVAIL_INFO_API_URL = props["apiHopperAvailUrl"];
        }
        else if (props && props["apiHopperAvailUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            HOPPER_AVAIL_INFO_API_URL = props["apiHopperAvailUrl"].replace('/voa', '');
        }
    } else {
        HOPPER_AVAIL_INFO_API_URL = constructApiUrl( process.env.REACT_APP_HOPPER_AVAIL_INFO_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_HOPPER_MFEES_REDIRECT_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiHopperMfeesUrl"] && sessionIntegrationMode === "VOA") {
            HOPPER_MFEES_REDIRECT_URL = props["apiHopperMfeesUrl"];
        }
        else if (props && props["apiHopperMfeesUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            HOPPER_MFEES_REDIRECT_URL = props["apiHopperMfeesUrl"].replace('/voa', '');
        }
    } else {
        HOPPER_MFEES_REDIRECT_URL = constructApiUrl( process.env.REACT_APP_HOPPER_MFEES_REDIRECT_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_HOPPER_INELIGIBLE_TYPES_SC) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["hopperIneligibleTypeSC"] && sessionIntegrationMode === "VOA") {
            HOPPER_INELIGIBLE_TYPES_SC = props["hopperIneligibleTypeSC"];
        }
        else if (props && props["hopperIneligibleTypeSC"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            HOPPER_INELIGIBLE_TYPES_SC = props["hopperIneligibleTypeSC"].replace('/voa', '');
        }
    }

    if (isNotEnvVarSet(process.env.REACT_APP_HOPPER_INELIGIBLE_TYPES_APV1) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["hopperIneligibleTypeAPV1"] && sessionIntegrationMode === "VOA") {
            HOPPER_INELIGIBLE_TYPES_APV1 = props["hopperIneligibleTypeAPV1"];
        }
        else if (props && props["hopperIneligibleTypeAPV1"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            HOPPER_INELIGIBLE_TYPES_APV1 = props["hopperIneligibleTypeAPV1"].replace('/voa', '');
        }
    }

    if (isNotEnvVarSet(process.env.REACT_APP_HOPPER_INELIGIBLE_TYPES_APV2) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["hopperIneligibleTypeSC"] && sessionIntegrationMode === "VOA") {
            HOPPER_INELIGIBLE_TYPES_APV2 = props["hopperIneligibleTypeAPV2"];
        }
        else if (props && props["hopperIneligibleTypeSC"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            HOPPER_INELIGIBLE_TYPES_APV2 = props["hopperIneligibleTypeAPV2"].replace('/voa', '');
        }
    }

    if (isNotEnvVarSet(process.env.REACT_APP_HOPPER_VSE_REDIRECT_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiHopperAvailUrl"] && sessionIntegrationMode === "VOA") {
            HOPPER_VSE_REDIRECT_URL = props["apiHopperAvailUrl"];
        }
        else if (props && props["apiHopperAvailUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            HOPPER_VSE_REDIRECT_URL = props["apiHopperAvailUrl"].replace('/voa', '');
        }
    } else {
        HOPPER_VSE_REDIRECT_URL = constructApiUrl( process.env.REACT_APP_HOPPER_VSE_REDIRECT_URL || "");
    }    

    if(isNotEnvVarSet(process.env.REACT_APP_GUEST_TERMS_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            if(props && props["guestTermsUrl"] && sessionIntegrationMode === "VOA") {
                GUEST_TERMS_API_URL = props["guestTermsUrl"];
                
            } else if(props && props["guestTermsUrl"] && sessionIntegrationMode === "AC") {
                console.log("VCAP AC");
                GUEST_TERMS_API_URL = props["guestTermsUrl"].replace('/voa', '');
            }
    } else {
        GUEST_TERMS_API_URL = constructApiUrl(process.env.REACT_APP_GUEST_TERMS_API_URL || "");
    }

    if(isNotEnvVarSet(process.env.REACT_APP_GUEST_PROFIEL_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            if(props && props["guestTermsUrl"] && sessionIntegrationMode === "VOA") {
                GUEST_PROFIEL_URL = props["guestTermsUrl"];
            } else if(props && props["guestTermsUrl"] && sessionIntegrationMode === "AC") {
                console.log("VCAP AC");
                GUEST_PROFIEL_URL = props["guestTermsUrl"].replace('/voa', '');
            }
    } else {
        GUEST_PROFIEL_URL = constructApiUrl(process.env.REACT_APP_GUEST_PROFIEL_URL || "");
    }

    // if(isNotEnvVarSet(process.env.REACT_APP_OWNER_INFO_API_URL) ||
    // [ReactAppMode.VOA].includes(EXEC_MODE)) {
    //     TRANSFER_POINTS_CONTRACTS_URL = process.env.REACT_APP_TRANSFER_POINTS_CONTRACTS_URL || "";
    // }

    if (isNotEnvVarSet(process.env.REACT_APP_TRANSFER_POINTS_CONTRACTS_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            //TODO: This will not work, since transfer points has not been configured for VCAP
        if (props && props["apiTranferPointsContractsUrl"] && sessionIntegrationMode === "VOA") {
            TRANSFER_POINTS_CONTRACTS_URL = props["apiTranferPointsContractsUrl"];
        } else if (props && props["apiTranferPointsContractsUrl"] && sessionIntegrationMode === "AC") {
            console.log("VCAP AC");
            TRANSFER_POINTS_CONTRACTS_URL = props["apiTranferPointsContractsUrl"].replace('/voa', '');
        }
    } else {
        TRANSFER_POINTS_CONTRACTS_URL = constructApiUrl( process.env.REACT_APP_TRANSFER_POINTS_CONTRACTS_URL || "");
    }
}

export default logLevel;
